import '@mod-publisher/js/richcontent/styling.css';
import './richeditor.scss';
import './internal/buttons.scss';
import './internal/widgets.scss';
